export const PACK_ON_ITS_WAY =
  "Pack is on its way. Call the bank, then come back if they stall.";

export const PACK_SEND_FAILED =
  "We couldn't send your pack just now. Your RateCheck result is still here — please try again or contact Azure Home Loans.";

export function packPartialMessage(phone: string): string {
  return `We have your details but couldn't email the pack. Call ${phone} and we'll send it.`;
}

export function packFailedMessage(phone: string): string {
  return `${PACK_SEND_FAILED} ${phone}.`;
}
